export const CURRENCY_SIGN = '£'
